import React, { PropTypes } from 'react';
import { childrenShape } from '@bibliocommons/bc-prop-types';
import './DisplayHeading.scss';

export default function DisplayHeading({ children, tag = 'h4' }) {
  const HeadingTag = tag;

  return (
    <HeadingTag className="cp-ugc-display-heading" tabIndex="-1">
      {children}
    </HeadingTag>
  );
}

DisplayHeading.propTypes = {
  children: childrenShape.isRequired,
  tag: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/shared/UGC/DisplayHeading/DisplayHeading.jsx